import { render, staticRenderFns } from "./AnalyseTable.vue?vue&type=template&id=2f96ca54"
import script from "./AnalyseTable.vue?vue&type=script&lang=js"
export * from "./AnalyseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports